/**
 * @Author wutao
 * @description 线下培训课程新增编辑页面
 * @Date 2020/2/21
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import OfflineProgramCategorySelectList from "./offlineProgramCategorySelectList";
import {Form, message, Popconfirm, Upload, Spin} from "antd";
let { WizContainer, WizAvatarUpload,ossFileUtils,modelUtils} = framework_tool;

let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip,Wizmessage,WizCheckbox } = component_tool;
let Item = Form.Item;
let Option = WizSelect.Option;
let {Session} = utils_tool;

import {  WizClassifySelectRe as ClassifySelect  } from '@/containers/common'
import moment from "moment";


class OfflineProgramDetail extends WizContainer {

  componentName = 'OfflineProgramDetail';

  constructor(props) {
    super(props);
    this.states=[{code: 0, codeName: "草稿"},
    {code: 1, codeName: "发布"},
    {code: 2, codeName: "关闭"}];

    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/face/offlineProgramList/offlineProgramDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('offlineProgramDetailUpd', initialValue)
      } else {
        initialValue = Session.get('offlineProgramDetailUpd') || {};
      }
      if(initialValue.status==1){
        this.states=[
        {code: 1, codeName: "发布"},
        {code: 2, codeName: "关闭"}];
      }
    }
    this.state = {
      codeVisible: false,
      offlineProgramCategoryVisible: false,
      img:null,
      coverImageShow:constants.files.sys_program_default_image,
      offlineId:initialValue.id,
    };
    this.initialValue = initialValue;
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/face/offlineProgramList/offlineProgramDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('offlineProgramDetailUpd', initialValue)
      } else {
        initialValue = Session.get('offlineProgramDetailUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({offlineId:initialValue.id})
    }
  }

  _componentDidMount() {
    const {history} = this.props;
    // this.doActions([
    //   {
    //     path: 'positionCategory/getPositionCategoryList', //获取岗位分类列表
    //     payload: {
    //       key: 'positionCategory_getPositionCategoryList',
    //       apiParams: {
    //         type: 'FOLDER'
    //       }
    //     },
    //     requireLoading: true,
    //   }
    // ])
  }

  propsAndStateOnChange = {
    addOfflineProgram: this._addOfflineProgramOver.bind(this),
    updateOfflineProgram: this._updateOfflineProgramOver.bind(this),
  };



  _removeFile=()=>{
    this.setState({
      coverImage:{}
    });
  };

  _loadFile = (name,size,type,base64Data)=>{
    this.setState({
      coverImage: {'name':name,'size':size,'type':type,'base64Data':base64Data}
    });
  };

  /**
   * 线下培训课程新增成功返回原页面，失败弹出提示
   */
  _addOfflineProgramOver(nextProps, nextState) {
    if (nextProps.addOfflineProgram.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/face/offlineProgramList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addOfflineProgram.msg);
    }
    return true;
  }

  /**
   * 线下培训课程修改成功返回原页面，失败弹出提示
   */
  _updateOfflineProgramOver(nextProps, nextState) {
    if (nextProps.updateOfflineProgram.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/face/offlineProgramList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateOfflineProgram.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'imgRandom') {
        if (value === null || value === undefined || !value) {
          fitterValues[key] = 1;
        } else {
          fitterValues[key] = 0;
        }
      } else if (key === 'endDate' && value != null && value != undefined) {
        fitterValues[key] = value.format("YYYY-MM-DD HH:mm:ss");
      //} else if(key === 'types' && value != null && value != undefined && value instanceof Array){
        // let list = []
        // value.forEach(e=>{
        //   list.push(e.key);
        // })
        // fitterValues[key] = list;
      }else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 线下培训课程信息
   * @param values
   * @private
   */
  _saveOfflineProgram(values) {
    values['img'] = values['img'] && values['img'][0] ? values['img'][0]['fileId'] : null
    const {history} = this.props;
    let apiPath = "offlineProgramManagement/add";
    let payloadKey = "addOfflineProgram";
    if (history.location && history.location.pathname === '/face/offlineProgramList/offlineProgramDetailUpd') {
      apiPath = "offlineProgramManagement/update";
      payloadKey = "updateOfflineProgram";
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  /**课程编码展示图片 */
  codeModal() {
    return (
      <WizModal
        visible={this.state.codeVisible}
        title={'主题编码规则'}
        width={600}
        footer={null}
        onCancel={() => this.setState({ codeVisible: false })}
      >
        {/* <div className="code-rule">课程编码示例: B_CP_S_IBT_201302_V1</div> */}
        <img width="550px" height="320px" src={constants.files.sys_program_code_rule} alt="主题编码图片" />
      </WizModal>
    )
  }

  /**培训课程分类选择 */
  offlineProgramCategoryModal() {
    return (
      <WizModal
        visible={this.state.offlineProgramCategoryVisible}
        title={'培训主题分类选择'}
        width={900}
        footer={null}
        onCancel={() => this.setState({ offlineProgramCategoryVisible: false })}
      >
        <OfflineProgramCategorySelectList />
      </WizModal>
    )
  }

  /**
   * 上传文件前的钩子：自定义校验
   */
  _beforeUpload = (file, showMessage = true) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng && showMessage) {
      message.error('请上传类型为JPG或者PNG的图片');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M && showMessage) {
      message.error('图片不得超过2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  /**
   * 获取base64类型的图片
   */
  _getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  /**
   * 上传图片
   */
  _changeImg = (info) => {
    let file = info[0].file;
    if (this._beforeUpload(file, false)) {
      this._getBase64(file.originFileObj, imageUrl => {
        this.setState({
          coverImageShow: imageUrl
        }, () => {
          //数据改变回调

        })
      })
    }
  };

  /**
   * 随机改变图片
   */
  _randomImg = () => {
  this.setState({
    coverImageShow:constants.files.sys_program_default_image
  })
};

  _render() {
    const {history, offlineProgramManagementLoading} = this.props;
    const {img, coverImageShow} = this.state;
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    const {id, status, coverType, endDate, imgRandom,category} = initialValue;
    let initialStatus = 1;
    let initialCategory = 0;
    let states=this.states;
    let initialCoverType = 0;
    let initialImgRandom = true;
    let initialEndDate = null;
    if (initialValue && id) {
      cardTitle = '编辑';
      initialStatus = status;
      initialCategory = category;
      if (coverType && coverType !=0 ) {
        initialCoverType = coverType;
      }
      if (endDate) {
        initialEndDate = endDate;
      }
      if (imgRandom && imgRandom !=0 ){
        initialImgRandom = false;
      }
    }
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.delFlag
        },
        name: "delFlag"
      },
      {
        title: "主题名称",
        name: "name",
        formItem: {
          initialValue: initialValue.name,
          maxlength: 25,
          rules: [{
            required: true,
            whitespace: true,
            message: '请输入主题名称',
          }, {
            max: 25,
            message: '主题名称长度不能超过25个字符'
          },
          //  {
          //   pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5《》()]{1,25}$/,
          //   message: '课程名称不允许使用特殊符号'
          // }
        ],
          placeholder: "请输入主题名称,长度不能超过25个字符"
        }
      },
      {
        title: "主题编码",
        name: "code",
        dataIndex: "code",
        formItem: {
          initialValue: initialValue.code,
          // placeholder: '请按照编码规则输入',
          // suffix: <a onClick={() => this.setState({ codeVisible: true })}>查看编码规则</a>,
          rules: [{
            required: true,
            message: '请输入主题编码',
          }, {
            max: 35,
            message: '主题编码长度不能超过35个字符'
          },
          // {
          //  // pattern: /^[A-Z][_][A-Z]{2}[_][A-Z][_][A-Z]{2,3}[_][\d]{6}[_][V][1-9]$/,
          //   pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5—]{1,35}$/,
          //   message: '请按照编码规则输入'
          // }
        ],

        },
      },
      {
        title: "所属分类",
        name: "types",
        formItem: {
          type: 'diy',

          diy: ClassifySelect,
          returnKey: true,
          wizTreeSelectListProps: {
            itemProps: {
              icon: 'unordered-list',
              title: '培训分类',
              tips: '请勾选所属培训分类'
            },
            treeProps: { checkStrictly: true }
          },
          apiProps: {type:1,state:1},
          //apiProps: { type: 3 },//线下课程与在线课程使用同一个分类
          selectProps: {
            placeholder: '请选择培训分类'
          },
          initialValue: initialValue.types ? initialValue.types : [],
          initSelects: initialValue.categoryInfo? initialValue.categoryInfo :[],
          //onClearWiz: this._onClearWiz.bind(this),
          rules: [
              { required: true, message: '请选择培训分类', type: 'array' },
          ],
          modalProps:{
            title:'选择所属分类'
          }
        },
      },
      {
        title: "类别",
        name: "category",
        dict: [
          {code: 0, codeName: "普通课程"},
          {code: 1, codeName: "新能源课程"},
        ],
        formItem: {
          type: "hidden",
          initialValue: initialCategory,
          disabled : initialValue && initialValue.id && initialValue.status!=0
        },

      },
      {
        title: '主题结束时间',
        name: 'endDate',
        formItem: {
          type: 'custom',
          initialValue : initialEndDate,
          rules: [
            { required: true, message: '请选择主题结束时间' },
          ],
          render: (record, form, otherProps) => {
            const {getFieldDecorator, getFieldValue, setFieldsValue} = form;
            const _initialValue = !otherProps?.initialValue || moment.isMoment(otherProps?.initialValue) ? otherProps?.initialValue : moment(otherProps?.initialValue);

            const TmpCheckbox = ({value, onChange}) => {
              const _onChange = (e) => {
                let date, callback = (call) => call && call()
                if(e.target?.checked) {
                  date = moment('2099-12-31 23:59:59')
                  callback = (call) => setFieldsValue({endDate: date}, call)
                }
                callback(() => onChange && onChange(e))
              }
              return <WizCheckbox checked={value} onChange={_onChange}>长期</WizCheckbox>
            }

            return [
              getFieldDecorator('endDate', {
                ...otherProps,
                initialValue: _initialValue,
              })(<WizDatePicker disabled={getFieldValue('longer') || false}/>),
              getFieldDecorator('longer', {
                initialValue: getFieldValue('endDate') >= moment('2099-12-31 00:00:00') || false,
              })(<TmpCheckbox/>)
            ]
          },
        },
      },
      // {
      //   title: '上传封面',
      //   formItem: {
      //     type: 'custom',
      //     render: (record, form) => {
      //       const { getFieldDecorator } = form;
      //       return (
      //         <div>
      //           {getFieldDecorator('coverType', {
      //             initialValue: initialCoverType
      //           })(
      //             <WizRadio.Group >
      //               <WizRadio value={0}>图片封面随机设置</WizRadio>
      //               {getFieldDecorator('imgRandom',
      //                 { valuePropName: 'checked' ,
      //                   initialValue : initialImgRandom})(
      //                 <WizSwitch
      //                   style={{ marginRight:20 }}
      //                   checkedChildren={<WizIcon type="check" />}
      //                   unCheckedChildren={<WizIcon type="close" />}
      //                 />
      //               )}
      //               <WizRadio value={1}>视频封面</WizRadio>
      //             </WizRadio.Group>
      //           )}
      //         </div>
      //       );
      //     }
      //   }
      // },
      {
         title: <span>
                  上传封面&nbsp;
                  <WizTooltip title="请上传大小不超过500KB,图片尺寸建议400*266">
                      <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>,
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;

              return(
                <div style={{ width:400}}>
                  {/* <img style={{ marginRight: 30, width: 200, height: 100 }} src={coverImageShow} /> */}
                  {/* <Upload
                  showUploadList={false}
                  beforeUpload={this._beforeUpload}
                  onChange={(...e) => { this._changeImg(e) }}
                  >
                    <WizButton>上传封面</WizButton>
                  </Upload> */}
                  <>
                  {getFieldDecorator('img', {
                          initialValue: (initialValue && initialValue.img) ? [
                              {fileId:initialValue.img}
                          ] : [],
                      })(
                          <WizAvatarUpload
                            accept={'.jpg, .jpeg, .png'}
                            listType={'picture-card'}
                            aspectRatio={400 / 266}
                            beforeUpload={(file) => {
                              const isLt1M = file.size / 1024 / 1024 < 0.5;
                              if (!isLt1M) {
                                Wizmessage.error('图片不得超过500k!');
                              }
                              return isLt1M;
                            }}
                          />
                      )}
                      </>
                </div>
              )
            }

          }

      },
      // {
      //   title: "封面图片ID",
      //   name: 'img',
      //   formItem: {
      //     type: "hidden",
      //     initialValue: img
      //   }
      // },
      {
        title: "状态",
        name: "status",
        dict:
          states
        ,
        formItem: {
          type: "radio",
          initialValue: initialStatus
        }
      },
      {
        title: "介绍",
        name: "intro",
        formItem: {
          type: 'textarea',
          placeholder: '请输入介绍最多输入100个字符',
          maxlength: 100,
          rules: [],
          initialValue: initialValue.intro
        },
      },

    ];

    let onSubmit = this._saveOfflineProgram.bind(this);

    let formProps = {
      ref: 'form',
      key: this.initialValue.id || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
      },
      style: {maxWidth: 800}
    }

    return (
      <WizCard>
        <Spin tip={'加载中'} spinning={offlineProgramManagementLoading}>
        <WizForm className={'form-inline'} {...formProps} />
        {this.codeModal()}
        {this.offlineProgramCategoryModal()}
        </Spin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {offlineProgramManagement} = state;
  const addOfflineProgram = modelUtils.getModelEntity(offlineProgramManagement, "addOfflineProgram");
  const updateOfflineProgram = modelUtils.getModelEntity(offlineProgramManagement, "updateOfflineProgram");
  const load = modelUtils.getLoadingState(state, ['offlineProgramManagement']);
  return {
    addOfflineProgram: addOfflineProgram,
    updateOfflineProgram: updateOfflineProgram,
    ...load
  }
};

export default connect(mapStateToProps)(OfflineProgramDetail);
